import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import cookies from '../../utils/cookies';

const PrivateRoute = ({ component: Component, ...rest }) => {
    const session = useSelector((state) => state.session);
    const hasAuthToken = !!cookies.get('auth_token');

    return (
        <Route
            {...rest}
            render={(props) =>
                hasAuthToken ? (
                    <Component {...props} session={session} />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: props.location || { pathname: '/home' } }
                        }}
                    />
                )
            }
        />
    );
};

export default PrivateRoute;
